import React, { Component } from 'react';
import PropTypes from 'prop-types';
import RecommendOffice from './RecommendOffice';
import PanelHeader from '../../shared/panel/_PanelHeader';
import Panel from '../../shared/panel/_Panel';

const Index = () => {
  return (
    <Panel className='manager__doctor-index__panel'>
      <PanelHeader>
        <div className='manager__doctor-index__panel__header__left'>
                    Recommend Office
        </div>
      </PanelHeader>
      <RecommendOffice />
    </Panel>
  );
};

Index.propTypes = {};

export default Index;



// WEBPACK FOOTER //
// ./app/components/managers/recommendOffice/Index.jsx